import { ArticleContainer } from '@3d-scene/model3d/article-container';

export class ArticleRotationGroup {
  public articleContainers: ArticleContainer[] = [];
  public rotateAsGroup: boolean = false;

  public data: any = null;

  public constructor(articleContainers: ArticleContainer[], rotateAsGroup: boolean = false) {
    this.articleContainers = articleContainers;
    this.rotateAsGroup = rotateAsGroup;
  }
}
